/** Sample URLs for the realistic dice roll loop (served from Vite public/). */
export const DICE_ROLL_SAMPLE_URLS = ['/audio/dice-roll.ogg', '/audio/dice-roll.mp3'] as const;

/** Minimum animation length (s) — loop the sample only when it is shorter. */
export const ROLL_ANIMATION_MIN_SEC = 1.85;

export type FetchFn = (url: string) => Promise<Response>;

/**
 * Loads and decodes the dice roll sample. Tries OGG first, then MP3.
 * Returns null on failure so gameplay can continue without roll audio.
 */
export async function loadDiceRollSample(
  ctx: AudioContext,
  fetchFn: FetchFn = fetch,
): Promise<AudioBuffer | null> {
  for (const url of DICE_ROLL_SAMPLE_URLS) {
    try {
      const res = await fetchFn(url);
      if (!res.ok) continue;
      const data = await res.arrayBuffer();
      return await ctx.decodeAudioData(data.slice(0));
    } catch {
      /* try next format */
    }
  }
  return null;
}
